/* Fann Bliss — open the theme's cart drawer after every fann add to bag.
   fann-home.js fires "fann:cart:updated" once an add succeeds (quick add, bundle builders, Teacher's sets, name pop-up).
   The Halo drawer (#halo-cart-sidebar) opens at once in its loading state, then fills with the theme's own side-cart
   view (through fann-cart-v2.js when it is on the page). The small "added" toast is dropped when the drawer opens and
   stays as the only feedback on pages without a drawer. */
(function () {
  'use strict';
  if (window.__fhCartOpen) return;
  window.__fhCartOpen = true;
  var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  var busy = false;

  function wrapEl() { return document.querySelector('#halo-cart-sidebar .previewCart-wrapper'); }
  function hideToast() { var t = document.querySelector('.fh-toast'); if (t) t.classList.remove('fh-on'); }

  function refreshOwn() {
    return fetch(root + 'cart?view=ajax_side_cart', { credentials: 'same-origin' })
      .then(function (r) { if (!r.ok) throw new Error('side cart'); return r.text(); })
      .then(function (html) { var w = wrapEl(); if (w) w.innerHTML = html; });
  }

  function open() {
    if (busy || !document.getElementById('halo-cart-sidebar')) return;
    busy = true;
    var w = wrapEl();
    if (w) w.classList.add('is-loading');
    document.body.classList.add('cart-sidebar-show');
    hideToast();
    var api = window.FannCartV2;
    var p = api && typeof api.refreshSideCart === 'function'
      ? fetch(root + 'cart.js', { headers: { Accept: 'application/json' }, credentials: 'same-origin' })
          .then(function (r) { return r.json(); })
          .then(function (cart) { return api.refreshSideCart(cart, true); })
      : refreshOwn();
    p.catch(function () { return refreshOwn().catch(function () {}); })
      .then(function () { var x = wrapEl(); if (x) x.classList.remove('is-loading'); busy = false; });
  }

  document.addEventListener('fann:cart:updated', open);
})();